import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core'

// HTTP connection to the API
const httpLink = new HttpLink({
  // DO NOT CHANGE BELOW!    Change your own  .env.local file please.
    uri: process.env.VUE_APP_GRAPHQL_HTTP || 'https://api.beautysku.com/',

})

console.log('httpLink==>', httpLink.options.uri)

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
export const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
  connectToDevTools: true,
})
